// src/pages/Home.js
import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import Topbar from '../components/Topbar';
import Navbar from "../components/Navbar";
import FootBar from '../components/FootBar';

const Home = () => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
    const images = [
      'bg-image-1',
      'bg-image-2',
      'bg-image-3',
      'bg-image-4',
    ];
  
    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 10000); // Change image every 5 seconds
  
      return () => clearInterval(interval); // Clear interval on unmount
    }, [images.length]);

  return (
    <div className="min-h-screen">
      <Topbar/>
      <Navbar/>
      
      {/* Hero Section with Carousel Background */}
      <section
        className={`bg-cover bg-no-repeat ${images[currentImageIndex]} h-[400px] sm:h-[600px] flex items-center justify-center`}
      >
        <div className="text-center text-white bg-black bg-opacity-50 p-6 rounded-md max-w-lg mx-4 sm:mx-auto">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4">Welcome to GPPAF</h1>
          <p className="text-base sm:text-lg mb-6">Empowering students with quality education</p>
          <button className="bg-yellow-600 text-white px-4 py-2 rounded-md hover:bg-yellow-700 transition">Get Started</button>
        </div>
      </section>

      {/* Mission Statement */}
      <section className="py-12 px-4 text-center">
        <h2 className="text-2xl sm:text-3xl font-bold mb-4">GLORY AND PRAISE PRIME ACADEMY FOUNDATION (GPPAF)</h2>
        <p className="text-gray-700 max-w-2xl md:max-w-3xl mx-auto text-base sm:text-lg">
        At GPPAF our watchword is Excellence. GPPAF is a co-educational school and presently consists of the Kindergarten/Nursery and Primary School, the Junior Secondary School and the Senior Secondary School, with Boarding Facilities. We are located in Kuje, on the outskirts of Abuja, in the Federal Capital Territory, not too far from the Nnamdi Azikiwe International Airport. The school buildings and grounds now include 20 buildings and recreation/sports facilities, all of which are meticulously maintained. Further expansion of schools infrastructure is however an ongoing process.

        Since its founding more than twenty one years ago,The fundamental mission policy of the school has been to provide the child with the unique education that brings out the best in him/her intellectually, emotionally, physically, morally and indeed spiritually.

        Our team is made up of graduates and specialists with vast teaching experience – We have a sound Curricular and a staunch commitment to adding positively to future generations.
        ...Read More
        </p>
      </section>

      {/* Call-to-Action Section */}
      <section className="py-8 px-4 bg-blue-100">
        <div className="max-w-4xl mx-auto text-center space-y-4">
          <h2 className="text-2xl sm:text-3xl font-bold">Join Us Today</h2>
          <p className="text-gray-700 text-base sm:text-lg">
            Become part of our community and start your educational journey.
          </p>
          <div className="flex justify-center space-x-4 flex-wrap">
            <Link to="/open-an-account"><button className="bg-yellow-600 text-white px-4 py-2 rounded-md hover:bg-yellow-700">Sign Up</button></Link>
            <Link to="/about-us"><button className="bg-gray-700 text-white px-4 py-2 rounded-md hover:bg-gray-900">Learn More</button></Link>
          </div>
        </div>
      </section>

      <FootBar />

    </div>
  );
};

export default Home;
